// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 12.9385H8.54911V11.0613H3V2.46929C3 2.21011 3.20704 2 3.46243 2C3.54034 2 3.61701 2.01998 3.68528 2.05809L20.7603 11.5887C20.9841 11.7137 21.0658 11.999 20.9427 12.2261C20.9004 12.3041 20.8371 12.3683 20.7603 12.4112L3.68528 21.9418C3.4615 22.0667 3.18032 21.9839 3.05724 21.7568C3.01969 21.6875 3 21.6097 3 21.5306V12.9385Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
